import { ManagerService } from '@appStore/managers/services/manager.service';

export const services: any[] = [ManagerService];

export * from '@appStore/managers/services/manager.service';
